export const IMG_R3_UPS = 'https://websiteoss.ecoflow.com/upload/image/1737540786514/d1.png'
export const IMG_R3_PLUS = 'https://websiteoss.ecoflow.com/upload/image/1737540883383/d2.png'
export const IMG_R3_MAX = 'https://websiteoss.ecoflow.com/upload/image/1737540886806/d3.png'
export const IMG_R3_MAX_PLUS = 'https://websiteoss.ecoflow.com/upload/image/1737540890115/d4.png'